import React from 'react';
import BaseVariables from '../index';

function DrugAccessVariables() {
    return (
        <BaseVariables variableGroup="Drug Access" />
    );
}

export default DrugAccessVariables;
